import React from 'react'
import './footer.css'
import {FiYoutube} from 'react-icons/fi'
import {FiInstagram} from 'react-icons/fi'
import {FiGithub} from 'react-icons/fi'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>At A Glance!</a>

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#playlists">Playlists</a></li>
        <li><a href="#memes">Memes</a></li>
        <li><a href="#shorts">Interesting Stuffs</a></li>
        <li><a href="#upcoming">Upcoming</a></li>
        <li><a href="#contact">Contact</a></li>
        <li><a href="https://www.spatial.io/s/At-A-Glance-64325f439f2805f7f09471d8?share=7035986176836881299" target="_blank">Virtual World!</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.youtube.com/@ataglanceofficial/" target="_blank"><FiYoutube/></a>
        <a href="https://www.instagram.com/at_a_glance_official/" target="_blank"><FiInstagram/></a>
        <a href="https://github.com/at-a-glance-official/" target="_blank"><FiGithub/></a>
      </div>

      <div className="footer__copyright">
        <small>©copy; At A Glance! All Rights Reserved</small>
      </div>
    </footer>
  )
}

export default Footer